import { sendGTMEvent } from '@next/third-parties/google'
import type { GtmGlobalStoreProps } from '../../useGTM'
import { getEcommerceObjectFromCart } from '../../helpers/getEcommerceObjectFromCart'

export type GtmCheckoutShippingAddedType = {
  scenario: 'entered_manually' | 'prefilled_automatically'
  data_provided: 'pickup' | 'address'
}

export const gtmCheckoutShippingAdded = ({
  globalStore,
  scenario,
  data_provided,
}: GtmGlobalStoreProps & GtmCheckoutShippingAddedType) => {
  const uuid = crypto.randomUUID()

  sendGTMEvent({
    event: 'add_shipping_info',
    event_id: uuid,
    scenario,
    data_provided,
    cart: getEcommerceObjectFromCart({
      globalStore,
      cart: [...globalStore.cart.otp, ...globalStore.cart.subscribe],
    }),
  })
}
